import { lazy } from 'react'

import RevenueGroupsLoader from './revenue-groups/loader'
import PreferencesLoader from './preferences/loader'

export default {
  RevenueGroups: {
    Component: lazy(() => import('./revenue-groups/RevenueGroups.Page')),
    Loader: RevenueGroupsLoader,
  },
  Preferences: {
    Component: lazy(() => import('./preferences/Preferences.Page')),
    Loader: PreferencesLoader,
  },
}
